export function checkSource () {
  let ua = window.navigator.userAgent.toLowerCase();
  // 判断是不是微信
  if ( ua.match(/MicroMessenger/i) == 'micromessenger' ) {
    return 1;
  }
  // 判断是不是支付宝
  if (ua.match(/AlipayClient/i) == 'alipayclient') {
    return 2;
  }
  // 哪个都不是
  return -1;
}

/**
 * 生成订单编号
 */
export function generateOrderNo(){
  let equipmentNo = '32839' // 写死
  let merchant = equipmentNo
  // 生成随机五位数
  let randomNum = getRandom(5)
  let dateStr = formateDateAndTimeToString(new Date())
  return dateStr+""+merchant+""+randomNum
}

//先创建函数来封装这个方法
function getRandom(num){
  let random = Math.floor((Math.random()+Math.floor(Math.random()*9+1))*Math.pow(10,num-1));
  return random
}

/**
 * 格式化日期
 * @param date
 * @returns {String}
 */
function formatDateToString(date){
  var year = date.getFullYear();
  var month = date.getMonth()+1;
  var day = date.getDate();
  if(month<10) month = "0"+month;
  if(day<10) day = "0"+day;
  return year+""+month+""+day;
}
function formateDateAndTimeToString(date)
{
  var hours = date.getHours();
  var mins = date.getMinutes();
  var secs = date.getSeconds();
  if(hours<10) hours = "0"+hours;
  if(mins<10) mins = "0"+mins;
  if(secs<10) secs = "0"+secs;
  return formatDateToString(date)+hours+mins+secs;
}



// WEBPACK FOOTER //
// ./src/utils/productUtil.js